<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

import AppLogo from "@/components/AppLogo.vue"
import UserInfoBar from "@/components/UserInfoBar.vue"
import SubscribeNotification from "@/components/parts/SubscribeNotification.vue"
import axios from '@/axios.config.js'
import Swal from 'sweetalert2'

const store = useStore()
const router = useRouter()
const { t } = useI18n()

const isMenuOpen = ref(false)

const isLoggedIn = computed(() => store.getters.isLoggedIn)
const isManager = computed(() => store.getters.isManager)
const isAdmin = computed(() => store.getters.isAdmin)
const isDraftsman = computed(() => store.getters.isDraftsman)
const isDistributor = computed(() => store.getters.isDistributor)
if (!isLoggedIn.value) {
  router.push('/login')
}
const goToDelivery = async () => {
  try {
    Swal.fire({
      title: t('sso.redirecting_title'),
      text: t('sso.redirecting_text'),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });

    const response = await axios.get('/api/sso/delivery');

    if (response.data && response.data.url) {
      Swal.close();
      window.open(response.data.url, '_blank');
    } else {
      throw new Error('Відсутнє посилання для переходу');
    }

  } catch (error) {
    console.error("Помилка переходу в Delivery:", error);

    Swal.fire({
      title: t('sso.error_title'),
      text: t('sso.error_text'),
      icon: 'error'
    });
  }
}
</script>

<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container align-items-center">

      <router-link class="navbar-brand" to="/">
        <AppLogo :width="90"/>
      </router-link>

      <div class="d-flex align-items-center gap-2 d-lg-none">
        <UserInfoBar/>
        <button class="navbar-toggler ms-2" type="button"
                aria-controls="navbarSupportedContent"
                :aria-expanded="isMenuOpen"
                aria-label="Toggle navigation"
                @click="isMenuOpen = !isMenuOpen">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>

      <div class="collapse navbar-collapse" :class="{ 'show': isMenuOpen }" id="navbarSupportedContent">

        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link class="nav-link pb-0" to="/">{{ t('navbar.mainPage') }}</router-link>
          </li>
          <li v-if="isManager || isDraftsman || isDistributor" class="nav-item">
            <router-link class="nav-link pb-0" to="/orders">{{ t('navbar.allOrderList') }}</router-link>
          </li>

          <li v-if="isAdmin || isDistributor" class="nav-item">
            <router-link class="nav-link pb-0" to="/adminpanel">
              {{ (isDistributor && !isAdmin) ? t('navbar.myClients') : t('navbar.adminPanel') }}
            </router-link>
          </li>

          <li v-if="isAdmin" class="nav-item">
            <router-link class="nav-link pb-0" to="/draftsmen-stats">
              {{ t('navbar.draftsmenStats') || 'Статистика складальників' }}
            </router-link>
          </li>
          <button v-if="isManager || isDraftsman || isDistributor" class="btn btn-primary" @click="goToDelivery">
            Перейти в Delivery
          </button>
        </ul>

        <div class="d-none d-lg-flex align-items-center">
          <UserInfoBar/>
          <SubscribeNotification/>
        </div>

        <div class="d-lg-none mt-3 border-top pt-3">
          <SubscribeNotification/>
        </div>

      </div>
    </div>
  </nav>
</template>

<style scoped lang="scss">
</style>